jQuery(document).ready(function () {
  function toggleMenuAttribute() {
    if (jQuery(window).width() > 990) {
      jQuery("nav > .list-menu > li").removeAttr("dw-open");
      jQuery("nav > .list-menu > li").find("details").removeAttr("open");

      jQuery(this).attr("dw-open", true);
      jQuery(this).find("details").attr("open", true);

      let position = jQuery(this).find("summary").offset();
      if (position) {
        let topPosition = parseInt(position.top);
        let finalPosion =
          topPosition + jQuery(this).find("summary").height() - 2;
        jQuery(this)
          .find(".mega-menu__content")
          .attr("style", "top:" + finalPosion + "px");
      }
    }
  }

  function removeMenu() {
    if (jQuery(window).width() > 990) {
      jQuery("nav > .list-menu > li").removeAttr("dw-open");
      jQuery("nav > .list-menu > li").find("details").removeAttr("open");
    }
  }

  // Initial setup
  toggleMenuAttribute();

  // Bind the function to the hover event and resize event
  jQuery(window).on("resize", toggleMenuAttribute);
  jQuery("nav > .list-menu > li").on({
    mouseenter: toggleMenuAttribute,
    mouseleave: toggleMenuAttribute,
  });

  //   comment for now
  jQuery("nav").on({
    mouseleave: removeMenu,
  });

  // console.log("menu");

  // Add slider for features Blue boxes on home page
  // .dw-features-block-home ul

  jQuery(".dw-features-block-home ul").slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1654,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1110,
        settings: {
          slidesToShow: 2,
        },
      },
      ,
      {
        breakpoint: 630,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  //   fix Search for mobile 22.11.2023
  jQuery(".dw-search-mobile").click(function (e) {
    // e.preventDefault();
    console.log("click search 2");
    // Prevent the default behavior of the anchor element
    // Your Liquid template rendering code
    //   {% render 'header-search', input_id: 'Search-In-Modal' %}
  });

  // Function to handle class changes
  var handleClassChange = function (mutationsList, observer) {
    for (var mutation of mutationsList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "class"
      ) {
        // Check if 'gl-search-open' class is now present
        if (jQuery("body").hasClass("gl-search-open")) {
          // Perform the action you want when the class is added
          console.log("Class 'gl-search-open' added to body!");
          jQuery("html, body").animate({ scrollTop: 0 }, "slow");
          // You can add your code here to scroll to the top or perform other actions
        }
      }
    }
  };

  // Create a MutationObserver
  var observer = new MutationObserver(handleClassChange);

  // Specify the target node and options for the observer
  var targetNode = document.querySelector("body");
  var config = { attributes: true, attributeFilter: ["class"] };

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
});

// cookie code 12/01/2023 ION
(function () {
  // your page initialization code here
  // the DOM will be available here
  // Function to set a cookie with a specific expiration time
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }

  // Function to check if a cookie is set
  function getCookie(name) {
    var nameEQ = name + "=";
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      while (cookie.charAt(0) === " ") {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(nameEQ) === 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  // Function to show the overlay and cookie modal if the cookie is not set
  function showCookieModal() {
    var overlay = document.querySelector(".dwyers-cookie-modal-overlay");
    var cookieModal = document.querySelector(".dwyers-cookie-modal");
    var acceptBtn = document.querySelector(".dwyers-accept-cookie-btn");
    var denyBtn = document.querySelector(".dwyers-deny-cookie-btn");

    if (overlay && cookieModal && acceptBtn && denyBtn) {
      //  delay 2 seonds
      setTimeout(function () {
        // Check if the 'dwyers_cookie_accepted' cookie is not set
        if (!getCookie("dwyers_cookie_accepted")) {
          overlay.style.display = "block";
          cookieModal.style.display = "block";

          // Add an event listener to the 'Accept' button
          acceptBtn.addEventListener("click", function () {
            // Set the 'dwyers_cookie_accepted' cookie with a value of 'true' and expire in 30 days
            setCookie("dwyers_cookie_accepted", "true", 30);
            // Hide the overlay and cookie modal
            overlay.style.display = "none";
            cookieModal.style.display = "none";
          });

          // Add an event listener to the 'Deny' button
          denyBtn.addEventListener("click", function () {
            // Set the 'dwyers_cookie_accepted' cookie with a value of 'false' and expire in 30 days
            setCookie("dwyers_cookie_accepted", "false", 30);
            // Hide the overlay and cookie modal
            overlay.style.display = "none";
            cookieModal.style.display = "none";
          });
        }
      }, 2000);
    }
  }

  // Call the showCookieModal function when the page is loaded
  window.onload = showCookieModal;
})();


// MOdal for Coffee
jQuery(document).ready(function () {
    let modal_coffee = document.querySelector(".coffee-cta");
    if (modal_coffee) {
      modal_coffee.addEventListener('click',function(e){
        e.preventDefault();
        let get_modal_content = document.querySelector(
          ".free-coffe-modal-wrap"
        );
        if (get_modal_content) {
          get_modal_content.setAttribute("style", "display:block");
        }

        let get_modal_overlay = document.querySelector(
          ".dwyers-cookie-modal-overlay"
        );
        if (get_modal_overlay) {
            get_modal_overlay.setAttribute("style", "display:block");
        }

        console.log("hey");
        
      },false);
    }

    let close_modal_coffee = document.querySelector(".close-modal-coffee");
    if (close_modal_coffee) {
        close_modal_coffee.addEventListener(
          "click",
          function (e) {
            let get_modal_content = document.querySelector(
              ".free-coffe-modal-wrap"
            );
            if (get_modal_content) {
              get_modal_content.setAttribute("style", "display:none");
            }

            let get_modal_overlay = document.querySelector(
              ".dwyers-cookie-modal-overlay"
            );
            if (get_modal_overlay) {
              get_modal_overlay.setAttribute("style", "display:none");
            }
          },
          false
        );
    }

});